import React from 'react';
import styles from './style.module.css';
import { Field } from 'redux-form';
import RenderRange from './range';
import Tooltip from '../tooltip';

export default ({
    meta: {
        error,
        submitFailed
    } = {},
    options = [],
    values = [],
    defaultValues = [],
    label,
    tooltip
} = {}) => (
    <div
        className={
            submitFailed && error ? styles.inputError : label ? styles.rangeInputContainer : styles.rangeInputContainerNoLabel
        }
    >
        {
            label &&
            <div className={`${styles.labelContainer} ${styles.labelContainerRangeGroup}`}>
                <label
                    className={styles.label}
                >
                    {label}
                </label>
                {
                    tooltip &&
                    <Tooltip content={tooltip}/>
                }
            </div>
        }
        <div className={styles.rangeGroupHeadings}>
            {
                Object.keys(values).map((key) =>
                    <p key={key} htmlFor={key} className={styles.label}>
                        {values[key]}
                    </p>
                )
            }
        </div>
        {
            Object.keys(options).map((key) =>
                <div key={key} className={styles.rangeGroupContainer}>
                    <label htmlFor={key} className={styles.label}>
                        {options[key]}
                    </label>
                    <div className={styles.rangeContainer}>
                        <Field
                            name={key}
                            key={key}
                            component={RenderRange}
                            defaultValue={defaultValues[key]}
                        />
                    </div>
                </div>
            )
        }
        {
            submitFailed && error &&
            error.map((message, i) => <span key={i} className={styles.errorMessage}>{message}</span>)
        }
    </div>
);
